<template>
  <div>
    <template>
      <v-form ref="form" lazy-validation @submit.prevent>
        <v-col flat color="white" class="mt-1" cols="12" sm="4">
          <v-select
            class="mr-3 pt-4"
            :items="selectItems"
            inputmode="tel"
            item-value="setting_group"
            item-text="setting_group_name"
            v-model="selectItem"
            label="設定種別"
            @input="getSystemMaster"
          ></v-select>
          <v-spacer></v-spacer>
        </v-col>
      </v-form>
    </template>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="golfGroupTbody"
      hide-default-footer
    >
      <template v-slot:[`item.bool_setting_value`]="{ item }">
        <v-checkbox v-model="item.bool_setting_value" @change="changeFlag(item)"/>
      </template>
      <template v-slot:[`item.dummy`]="{ item }">
        <v-col cols="12" v-if="item.setting_key === 'features_chat'">※サイドメニュー、予約状況一覧画面の表示も切り替わります</v-col>
        <v-col cols="12" v-if="item.setting_key === 'features_card'">※サイドメニュー、会員一覧画面の表示も切り替わります</v-col>
        <v-col cols="12" v-if="item.setting_key === 'cooperation_line'">※サイドメニューの表示も切り替わります</v-col>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="btn[1].isActive" color="green darken-4" text @click="onRegist()">登録</v-btn>
    </v-card-actions>
    <ChangeOverlay
      page-name="連携アプリケーション"
      @processing="updateSystemMaster"
      @cancel="closeChangeOverLay"
      :process-result="process"
      :OverlaySwitch="changeOverlay"
    />
  </div>
</template>

<script>
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
// graghql
import { GET_SETTING_GROUP_LIST, GET_SYSTEM_MASTER, UPDATE_SYSTEM_MASTER } from '@/constants/system_master';
import { CODE_MASTER } from '@/views/config';

export default {
    components: {
        ChangeOverlay
    },
    mixins: [
        authorityMixin
    ],
    data () {
        return {
            selectItems: [],
            selectItem: '',
            desserts: [],
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: '機能名', value: 'setting_name', align: 'left', sortable: false, width: 400 },
                { text: '有効／無効', value: 'bool_setting_value', align: 'center', sortable: false, width: 100 },
                { text: '', value: 'dummy', sortable: false, align: 'left' }
            ],
            // ボタンの活性・非活性（authorityMixinを使用する場合は必須）
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '追加', isActive: true }
            ],
            changeOverlay: false,
            processing: false,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            originChatboxSetting: 0,
            newChatboxSetting: 0,
            originPointSetting: 0,
            newPointSetting: 0,
            vue_id: 'SCR0103'
        };
    },
    created () {
        this.initialize();
    },
    watch: {
        //
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit('loading/setIsLoading', true);

            this.admin = await this.getLoginAdmin();
            await this.getAuthorityList();
            // 設定グループ取得
            this.getSettingGroupList();
        },
        /* --------------------------------------------
        * 設定グループ取得
        * -------------------------------------------- */
        getSettingGroupList: async function () {
            try {
                let res = await this.$apollo.query({
                    query: GET_SETTING_GROUP_LIST,
                    variables: {
                        settingType: 1
                    }
                });
                var result = res.data.GetSettingGroupList.SettingGroupLists;
                var workItems = [];
                for (var i = 0; i < result.length; i++) {
                    var item = result[i];
                    if (item.setting_group !== 'companion_setting' &&
                        this.admin.golf_code !== CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_SUPERUSER_CODE
                    ) {
                        continue;
                    }
                    workItems.push(item);
                }
                this.selectItems = workItems;
                this.selectItem = res.data.GetSettingGroupList.SettingGroupLists[0].setting_group;
                this.getSystemMaster();
            } catch (error) {
                this.error = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },

        /** --------------------------------------------
        * 設定値を取得
        * -------------------------------------------- */
        async getSystemMaster () {
            try {
                this.$apollo.query({
                    query: GET_SYSTEM_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: this.selectItem
                    }
                }).then(res => {
                    this.desserts = res.data.GetSystemMaster.SystemMasterLists;
                    for (var i = 0; i < this.desserts.length; i++) {
                        if (this.desserts[i].setting_value === 1) {
                            this.desserts[i]['bool_setting_value'] = true;
                        } else {
                            this.desserts[i]['bool_setting_value'] = false;
                        }

                        // サイドメニューを更新するため、変更前の設定を保持する
                        if (this.desserts[i]['setting_group'] === 'features_option' && this.desserts[i]['setting_key'] === 'features_point') {
                            this.originPointSetting = this.desserts[i]['bool_setting_value'];
                            this.newPointSetting = this.desserts[i]['bool_setting_value'];
                        } else if (this.desserts[i]['setting_group'] === 'features_option' && this.desserts[i]['setting_key'] === 'features_chat') {
                            this.originChatboxSetting = this.desserts[i]['bool_setting_value'];
                            this.newChatboxSetting = this.desserts[i]['bool_setting_value'];
                        }
                    };
                    this.$store.commit('loading/setIsLoading', false);
                });
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * スキャンコードの初期値変更時のオン・オフを切り替える
         * ---------------------------------------------- */
        changeFlag (item) {
            if (item.setting_group === 'features_member_code') {
                this.desserts.forEach(element => {
                    if (element.setting_key === item.setting_key) {
                        element.bool_setting_value = item.bool_setting_value;
                    } else {
                        element.bool_setting_value = !item.bool_setting_value;
                    }
                });
                let data = this.desserts;
                this.desserts = [];
                this.desserts = data;
            } else if (item.setting_group === 'features_option' && item.setting_key === 'features_point') {
                this.newPointSetting = item.bool_setting_value;
            } else if (item.setting_group === 'features_option' && item.setting_key === 'features_chat') {
                this.newChatboxSetting = item.bool_setting_value;
            }
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            if (this.process.result === 1) {
                if (
                    (this.originPointSetting !== this.newPointSetting) ||
                    (this.originChatboxSetting !== this.newChatboxSetting)
                ) {
                    this.$nextTick(function () {
                        this.$router.go({ path: this.$router.currentRoute.path, force: true });
                    });
                }
            }
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** --------------------------------------------
        * コース一覧を取得
        * -------------------------------------------- */
        onRegist () {
            var updateData = [];
            // setting_valueの値が全てOFFか、値を加算し判定するためのフラグ。
            var allOffFlag = 0;
            for (var i = 0; i < this.desserts.length; i++) {
                if (this.desserts[i].bool_setting_value) {
                    this.desserts[i].setting_value = 1;
                } else {
                    this.desserts[i].setting_value = 0;
                }
                // 設定がONならallOffFlagが+1される。全てがOFFのままなら0になる。
                allOffFlag += this.desserts[i].setting_value;
                let updateRec = {
                    setting_group: this.desserts[i].setting_group,
                    setting_key: this.desserts[i].setting_key,
                    setting_value: this.desserts[i].setting_value
                };
                updateData.push(updateRec);
            }
            // 同伴者設定のsetting_valueが全てOFFならエラーを返す。
            if (this.selectItem === 'companion_setting') {
                if (allOffFlag === 0) {
                    alert('同伴者設定はメールか携帯電話かのいずれかを有効にしてください。');
                    return;
                }
            }
            this.updateSystemMaster(updateData);
        },
        /** --------------------------------------------
        * コース一覧を取得
        * -------------------------------------------- */
        updateSystemMaster: function (updateData) {
            this.processing = true;
            // システムマスタ更新
            this.$apollo.mutate({
                mutation: UPDATE_SYSTEM_MASTER,
                variables: {
                    UpdateSystemMasterList: updateData
                }
            }).then(res => {
                this.process.result = res.data.UpdateSystemMaster.result;
                if (res.data.UpdateSystemMaster.result === 0) {
                    this.process.resultText = this.$t('result.error.change');
                    this.changeOverlay = true;
                    this.processing = false;
                } else if (res.data.UpdateSystemMaster.result === 1) {
                    this.process.resultText = this.$t('result.success.change');
                    if (
                        (this.originPointSetting !== this.newPointSetting) ||
                        (this.originChatboxSetting !== this.newChatboxSetting)
                    ) {
                        this.process.resultText += '\nメニューを更新するため画面を更新します。';
                    }
                    this.changeOverlay = true;
                    this.processing = false;
                }
            }).catch(error => {
                this.error = error;
                this.process.resultText = this.$t('result.error.change');
                this.changeOverlay = true;
                this.processing = false;
            });
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
